export default __webpack_public_path__ + "static/media/7.Ultra-Filtration-System.caec156a.jpg";